import firebase from 'firebase';

// Initialize Firebase
var config = {
  apiKey: "AIzaSyAauVTzpvPX0aw7qvuOMIJuvNi7fom_mTU",
  authDomain: "rw-people-ops-dev.firebaseapp.com",
  databaseURL: "https://rw-people-ops-dev.firebaseio.com",
  projectId: "rw-people-ops-dev",
  storageBucket: "rw-people-ops-dev.appspot.com",
  messagingSenderId: "71978690716"
};

if (process.env.REACT_APP_ENV === 'production') {
  config = {
    apiKey: "AIzaSyBV_VPJIbs9FpuMgPINn9jYYWcgBudwj0Q",
    authDomain: "rw-people-ops-bb0ec.firebaseapp.com",
    databaseURL: "https://rw-people-ops-bb0ec.firebaseio.com",
    projectId: "rw-people-ops-bb0ec",
    storageBucket: "rw-people-ops-bb0ec.appspot.com",
    messagingSenderId: "228428148560"
  };
}

firebase.initializeApp(config);

export default firebase;



// WEBPACK FOOTER //
// ./src/helpers/firebase.js